<script lang="ts" setup>
const { useRef } = useLayoutStore()

const [slogan] = useRef('slogan')

const texts = `我々のミッションは、<br/>
              時代にフィットした次世代型の越境調達サービス提供により、<br/>
              小売事業者様の様々な課題を解決し、<br/>
              仕入の新・常識を創ることです。`
</script>

<template>
  <div id="home" class=" bg-[#FFE8BB]" ref="slogan">
    <ADevice>
      <template #h5>
        <MContainer class=" py-10">
          <MRow class=" mb-12">
            <img class=" h-[72px]" src="https://static-jp.theckb.com/static-asset/xr/logo1.png" alt="">
          </MRow>
          <MRow class=" justify-end py-2">
            <img class=" h-[80px]" src="https://static-jp.theckb.com/static-asset/xr/logo3.png" alt="">
          </MRow>
          <MRow class=" justify-end mb-2">
            <img class=" h-[32px]" src="https://static-jp.theckb.com/static-asset/xr/logo2.png" alt="">
          </MRow>
          <MRow class="!items-end gap-1.5">
            <MText size="xs" class=" font-[900]">WHO WE ARE</MText>
            <img class=" h-6" src="/assets/image/icon/arrow-up.png" alt="">
          </MRow>
        </MContainer>
        <MContainer class=" py-12">
          <MCol class=" gap-6 pb-8 relative">
            <MText size="h1" placement="left" class=" font-[900]">ミッション</MText>
            <MText size="lg" placement="left" class=" leading-[32px]" v-html="texts"></MText>
            <img class=" h-[80px] absolute right-0 bottom-0"
              src="https://static-jp.theckb.com/static-asset/xr/mission_h5.png" alt="">
          </MCol>
        </MContainer>
      </template>
      <template #pc>
        <AContainer class=" px-[72px] py-[72px]">
          <div class=" relative flex flex-col pt-[48px] pb-[40px]">
            <MRow class=" absolute top-0 left-0">
              <img class=" h-[240px]" src="https://static-jp.theckb.com/static-asset/xr/logo1.png" alt="">
            </MRow>
            <MRow class=" justify-end my-[12px]">
              <img class=" h-[240px]" src="https://static-jp.theckb.com/static-asset/xr/logo3.png" alt="">
            </MRow>
            <MRow class=" justify-end my-[12px]">
              <img class=" h-[108px]" src="https://static-jp.theckb.com/static-asset/xr/logo2.png" alt="">
            </MRow>
            <MRow class="!items-end gap-[10px]">
              <MText class=" font-[500] leading-[16px]">WHO WE ARE</MText>
              <img class=" h-[50px]" src="/assets/image/icon/arrow-up.png" alt="">
            </MRow>
          </div>
          <div class=" pt-[72px] flex items-start justify-between">
            <img class=" h-[48px] ml-[88px]" src="https://static-jp.theckb.com/static-asset/xr/text.png" alt="">
            <div class=" flex-1 font-[16px] leading-[32px] ml-[82px]" v-html="texts"></div>
            <img class=" h-[128px]" src="https://static-jp.theckb.com/static-asset/xr/mission.png" alt="">
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
